import axiosInstance from './axiosConfig';

export const EVENT_COLORS = [
  { id: 'blue', label: 'Blue', hex: '#3b82f6' },
  { id: 'green', label: 'Green', hex: '#10b981' },
  { id: 'violet', label: 'Violet', hex: '#8b5cf6' },
  { id: 'red', label: 'Red', hex: '#ef4444' },
  { id: 'amber', label: 'Amber', hex: '#f59e0b' },
  { id: 'teal', label: 'Teal', hex: '#14b8a6' },
  { id: 'indigo', label: 'Indigo', hex: '#6366f1' },
  { id: 'slate', label: 'Slate', hex: '#64748b' },
];

export const colorHex = (id) => EVENT_COLORS.find((c) => c.id === id)?.hex || '#3b82f6';

export const RECURRENCE_FREQS = [
  { id: 'none', label: 'Does not repeat' },
  { id: 'daily', label: 'Daily' },
  { id: 'weekly', label: 'Weekly' },
  { id: 'monthly', label: 'Monthly' },
  { id: 'yearly', label: 'Yearly' },
];

export const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/**
 * Client for the ATOZAS Calendar backend (/api/calendar/*).
 */
export const calendarApi = {
  listEvents: (params = {}) =>
    axiosInstance.get('/api/calendar/events', { params }).then((r) => r.data),
  agenda: (days = 30) =>
    axiosInstance.get('/api/calendar/agenda', { params: { days } }).then((r) => r.data),
  createEvent: (payload) =>
    axiosInstance.post('/api/calendar/events', payload).then((r) => r.data),
  /** Turn an email into an event; `start` must be supplied by the user. */
  createFromMail: (mailId, overrides = {}) =>
    axiosInstance
      .post('/api/calendar/events/from-mail', { mailId, ...overrides })
      .then((r) => r.data),
  updateEvent: (id, payload) =>
    axiosInstance.put(`/api/calendar/events/${encodeURIComponent(id)}`, payload).then((r) => r.data),
  /** scope: 'series' removes the whole series, 'occurrence' skips one date. */
  deleteEvent: (id, scope = 'series') =>
    axiosInstance
      .delete(`/api/calendar/events/${encodeURIComponent(id)}`, { params: { scope } })
      .then((r) => r.data),
  /** Event reminders that are due now (polled by ReminderWatcher). */
  dueReminders: () => axiosInstance.get('/api/calendar/reminders').then((r) => r.data),
  /** Events others have invited me to, within an optional range. */
  invitations: (params = {}) =>
    axiosInstance.get('/api/calendar/invitations', { params }).then((r) => r.data),
  /** Free/busy for me + any ATOZAS users among `emails` (comma string). */
  freeBusy: (params = {}) =>
    axiosInstance.get('/api/calendar/free-busy', { params }).then((r) => r.data),
  /** Scheduling assistant: suggest open slots for the given participants. */
  suggest: (payload) => axiosInstance.post('/api/calendar/suggest', payload).then((r) => r.data),
  /** Respond to an invitation: accepted | declined | tentative | needs-action. */
  rsvp: (id, response) =>
    axiosInstance
      .post(`/api/calendar/events/${encodeURIComponent(id)}/rsvp`, { response })
      .then((r) => r.data),
};

export const RSVP_OPTIONS = [
  { id: 'accepted', label: 'Yes', icon: '✓' },
  { id: 'tentative', label: 'Maybe', icon: '?' },
  { id: 'declined', label: 'No', icon: '✕' },
];

export default calendarApi;
